var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XLMTxContainer',{attrs:{"tx":_vm.tx}},[(_vm.mq_gte_md)?_c('AccountDetail',{attrs:{"account":_vm.destination,"text":"Destination"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }